/* @flow */

import React from 'react';
import InfiniteScroll from 'depop/components/InfiniteScroll';

import Ball from 'depop/components/loaders/Ball';

type Props = {
  children: React.Element,
  hasMore: boolean,
  loadMore: () => void,
  useWindow: boolean,
};

const SimpleInfiniteScroll = ({children, hasMore, loadMore, useWindow = true}: Props) => (
  <InfiniteScroll
    style={{maxWidth: '100%'}}
    pageStart={0}
    loadMore={loadMore}
    hasMore={hasMore}
    loader={<Ball />}
    useWindow={useWindow}
    threshold={500}>
    {children}
  </InfiniteScroll>
);

export default SimpleInfiniteScroll;



// WEBPACK FOOTER //
// ../src/client/components/SimpleInfiniteScroll.js